import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import { Form } from '@rocketseat/unform';

import {
  Button,
  WrapperFlex,
  Title,
  Breadcrumbs,
} from '@unimed-fesp/components';

import { FaThumbsUp } from 'react-icons/fa';
import { IoMdCheckboxOutline } from 'react-icons/io';
import { set } from 'lodash';

import history from '../../services/history';

import {
  TipoListaEnum,
  StatusEnvioListaEnum,
  MovimentacaoListaEnum,
} from '../../enums';

import useMovimentacao from '../../hooks/useMovimentacao';
import useModal from '../../hooks/useModal';
import useQueue from '../../hooks/useQueue';

import { Creators as ListaActions } from '../../store/ducks/lista';

import theme from '../../styles/theme';
import CollapseListaDetalhe from '../../components/organisms/CollapseListaDetalhe';
import ModalSuccess from '../../components/organisms/ModalSuccess';

import { Container } from './styles';

function DetalheListas() {
  const dispatch = useDispatch();

  const {
    loading,
    putListas,
    isPostArquivoImportacaoSuccess,
    postImportarLote,
    postArquivoImportacao,
    patchListaStatus,
    patchValidacaoListaTransferencia,
  } = useSelector((state) => state.lista);

  const REQ_PUT_ID = 1;
  const REQ_PATCH_ID = 2;

  const { setDescricao, setTipoEnvio, handleDeleteFiles } = useMovimentacao();
  const success = useModal(false, '', (_) => _);
  const error = useModal(false, '', (_) => _);
  const [
    addSuccess,
    removeSuccess,
    finishSuccess,
    setFinishSuccess,
    updateSuccess,
    resetSuccess,
  ] = useQueue([]);

  // const [
  //   addError,
  //   removeError,
  //   finishError,
  //   setFinishError,
  //   updateError,
  // ] = useQueue([]);

  const [initialData, setInitialData] = useState();
  const [isOnlySave, setIsOnlySave] = useState(false);

  const handleInitialData = useCallback(() => {
    const initialDataObj = {
      descricao: [],
    };
    postImportarLote.files.map((files) => {
      set(initialDataObj.descricao, files.idLista, files.descricao);
    });

    setInitialData(initialDataObj);
  }, [postImportarLote.files]);

  function handleSubmit(data) {
    setDescricao(postImportarLote.files, data, () => {
      // addSuccess({ id: REQ_PUT_ID, trigger: putListas.success });
      // addError({ id: REQ_PUT_ID, trigger: putListas.isError });
    });
  }

  const isLoading = () => {
    return (
      putListas.loading ||
      postArquivoImportacao.loading ||
      patchListaStatus.loading
    );
  };

  const handleFiles = (file) => {
    dispatch(ListaActions.postArquivoImportacaoRequest(file));
  };
  // // #region UseEffect para lidar com sucesso
  // useEffect(() => {
  //   if (putListas.success) {
  //     updateSuccess({ id: REQ_PUT_ID, trigger: putListas.success });
  //     // removeError(REQ_PUT_ID);
  //   }
  // }, [putListas.success]);
  // useEffect(() => {
  //   if (patchListaStatus.success) {
  //     updateSuccess({ id: REQ_PATCH_ID, trigger: patchListaStatus.success });
  //     // removeError(REQ_PATCH_ID);
  //   }
  // }, [patchListaStatus.success]);
  // // #endregion

  // // #region UseEffect para lidar com error
  // useEffect(() => {
  //   if (putListas.isError) {
  //     // updateError({ id: REQ_PUT_ID, trigger: putListas.isError });
  //     removeSuccess(REQ_PUT_ID);
  //     setIsOnlySave(false);
  //     // resetSuccess();
  //   }
  // }, [putListas.isError]);
  // useEffect(() => {
  //   if (patchListaStatus.isError) {
  //     // updateError({ id: REQ_PATCH_ID, trigger: patchListaStatus.isError });
  //     removeSuccess(REQ_PATCH_ID);
  //     // resetSuccess();
  //   }
  // }, [patchListaStatus.isError]);
  // // #endregion

  // useEffect(() => {
  //   if (finishSuccess) {
  //     success.setParams(true, 'Informações salvas com sucesso!');
  //     setFinishSuccess(false);
  //   }
  // }, [finishSuccess, dispatch]);
  // useEffect(() => {
  //   if (finishError) {
  //     error.setParams(true, 'Erro ao salvar informações!');
  //     setFinishError(false);
  //   }
  // }, [finishError, dispatch]);

  const renewActions = () => {
    batch(() => {
      dispatch(ListaActions.deleteListaRenew());
      dispatch(ListaActions.putListasRenew());
      dispatch(ListaActions.patchListaStatusRenew());
    });
    history.push('/novo/lista');
  };

  useEffect(() => {
    if (postImportarLote.files.length > 0) {
      handleInitialData();
    } else {
      renewActions();
    }
  }, [postImportarLote.files, handleInitialData]);

  return (
    <Container>
      <Form onSubmit={handleSubmit} initialData={initialData}>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text="importar lote"
              color={theme.titleGray}
              fontSize={38}
              marginBottom={8}
            />
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              { path: 'lista', onNavigate: () => history.push('/novo/lista') },
              {
                path: 'importar lote',
                onNavigate: () => history.push('/novo/lista/importar-lote'),
              },
            ]}
          />
        </WrapperFlex>
        <WrapperFlex justifyStart alignStart column>
          {postImportarLote.files.map((file) => (
            <CollapseListaDetalhe
              file={file}
              uploadSuccess={isPostArquivoImportacaoSuccess}
              onClickHandleCancelList={handleDeleteFiles}
              acao={
                MovimentacaoListaEnum.returnIdForName[
                  postImportarLote.tipoMovimentacao
                ]
              }
              handleFiles={handleFiles}
              loading={postArquivoImportacao.loading}
            />
          ))}
        </WrapperFlex>
        <WrapperFlex>
          {TipoListaEnum.returnName[postImportarLote.tipoMovimentacao] !==
          TipoListaEnum.returnName.Transferencia ? (
            <Button
              tipo="tertiary"
              justifyCenter
              alignCenter
              type="submit"
              disabled={isLoading() ? 'disabled' : null}
              font="16px unimed_slabregular"
              onClick={() => {
                setIsOnlySave(true);
              }}
            >
              salvar
            </Button>
          ) : null}
          <WrapperFlex fullWidth justifyEnd alignEnd marginSides={10} flexWrap>
            {TipoListaEnum.returnName[postImportarLote.tipoMovimentacao] !==
            TipoListaEnum.returnName.Transferencia ? (
              <Button
                tipo="secondary"
                paddingTop={8}
                paddingRight={8}
                paddingBottom={8}
                paddingLeft={8}
                padding={8}
                justifySpaceBetween
                alignCenter
                width={122}
                marginRight={10}
                marginLeft={10}
                font="16px unimed_slabregular"
                onClick={() => {
                  setTipoEnvio(
                    StatusEnvioListaEnum.returnIdForName.Processamento,
                    MovimentacaoListaEnum.returnIdForName[
                      postImportarLote.tipoMovimentacao
                    ],
                    postImportarLote.files
                    // () => {
                    //   addSuccess({
                    //     id: REQ_PATCH_ID,
                    //     trigger: patchListaStatus.success,
                    //   });
                    //   addError({
                    //     id: REQ_PATCH_ID,
                    //     trigger: patchListaStatus.isError,
                    //   });
                    // }
                  );
                }}
              >
                <IoMdCheckboxOutline color="#00995d" />
                processar
              </Button>
            ) : null}
            <Button
              tipo="primary"
              paddingTop={10}
              paddingRight={10}
              paddingBottom={10}
              paddingLeft={10}
              justifySpaceBetween
              alignCenter
              width={104}
              font="16px unimed_slabregular"
              onClick={() => {
                setTipoEnvio(
                  StatusEnvioListaEnum.returnIdForName.Validacao,
                  MovimentacaoListaEnum.returnIdForName[
                    postImportarLote.tipoMovimentacao
                  ],
                  postImportarLote.files
                  // () => {
                  //   addSuccess({
                  //     id: REQ_PATCH_ID,
                  //     trigger: patchListaStatus.success,
                  //   });
                  //   addError({
                  //     id: REQ_PATCH_ID,
                  //     trigger: patchListaStatus.isError,
                  //   });
                  // }
                );
              }}
            >
              <FaThumbsUp color="#FFFF" />
              validar
            </Button>
          </WrapperFlex>
        </WrapperFlex>
      </Form>
      <ModalSuccess
        text={success.modal.message}
        onClick={() =>
          success.toogleModal(
            !isOnlySave ? () => renewActions() : () => setIsOnlySave(false)
          )
        }
        isOpen={success.modal.isOpen}
      />
      {/* <ModalError
        text={error.modal.message}
        onClick={() => error.toogleModal(() => setIsOnlySave(false))}
        isOpen={error.modal.isOpen}
      /> */}
    </Container>
  );
}

export default DetalheListas;
